import { Modal } from '@dd3tech/wiggui/Modal'
import Button from '@dd3tech/wiggui/Button'
import { MdOutlineWarning, MdClose, MdOutlineDelete } from 'react-icons/md'
import { useModalRemoveItemListStore } from '../../store/modals/modal-remove-item-list-store'

export const ModalRemoveItemFromList = () => {
  const { modalRemoveItemList } = useModalRemoveItemListStore()
  const { onClose, onConfirm, isOpen, isLoading, propertyAddress } =
    modalRemoveItemList
  const handleConfirm = () => {
    onConfirm()
  }

  return (
    <Modal
      closeOnEscape
      closeOnOutsideClick
      enableBgBlur
      isOpen={isOpen}
      onClose={onClose}
    >
      <Modal.Header className="pt-3 w-full flex items-center justify-between px-4 pb-1 pt-3 border-b border-surface-strokes">
        <p className="text-sm font-semibold">Quitar propiedad de la lista</p>
        <button
          className="rounded-full p-1 flex items-center justify-center hover:bg-surface-gray-10 transition-all duration-300 ease-in-out active:bg-surface-gray-20"
          onClick={onClose}
        >
          <MdClose className="w-6 h-6 text-primary" />
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="flex items-start gap-4">
          <div className="hidden md:flex md:flex-shrink-0">
            <MdOutlineWarning className="w-8 h-8 text-orange-500 min-w-[32px] min-h-[32px]" />
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              ¿Estás seguro de quitar esta propiedad?
            </h3>
            <p className="text-gray-600 text-sm mb-4">
              Esta acción removerá la propiedad de tu lista. Podrás agregarla
              nuevamente más tarde si lo deseas.
            </p>
            {propertyAddress && (
              <div className="bg-gray-50 rounded-lg p-3">
                <p className="text-sm font-medium text-gray-700">Propiedad:</p>
                <p className="text-sm text-gray-600 truncate">
                  {propertyAddress}
                </p>
              </div>
            )}
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer
        isShowDivider
        className="flex items-start justify-center flex-col sm:flex-row sm:items-center sm:justify-between gap-2 w-full px-6 border-t border-surface-strokes py-[9px]"
      >
        <Button
          onClick={onClose}
          variant="terciary"
          fullWidth
          isDisabled={isLoading}
        >
          Cancelar
        </Button>
        <Button
          fullWidth
          onClick={handleConfirm}
          isDisabled={isLoading}
          isLoading={isLoading}
          variant="cancel"
          rightIcon={
            <MdOutlineDelete className="min-w-[24px] min-h-[24px] text-white" />
          }
        >
          {isLoading ? 'Quitando...' : 'Quitar propiedad'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
